// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__Z4jVh","resendInfoText":"OnGoingPaymentBox_resendInfoText__3cTCI"};